import React from 'react';
import PropTypes from "prop-types";
import { Link } from "gatsby";

const Breadcrumbs = ({ breadcrumbs, pageUrl }) => {
  const separator = ' / ';
  return (
    <div className="breadcrumbs wrapper">
      <div className="bc-list">
        {breadcrumbs && breadcrumbs.length > 0 ?
          breadcrumbs.map((breadcrumb, index) =>
            {
              return (
                <div key={index + breadcrumb.url} className="crumb">
                  {breadcrumb.url.replace("/category", "").replace(process.env.WP_BC_URL, "") !== pageUrl ?
                    <>
                      <Link key={index + breadcrumb.url} to={breadcrumb.url.replace("/category", "") || "/"}>
                        {breadcrumb.url === '/' ?
                          <span>Home</span>
                          : <span dangerouslySetInnerHTML={{ __html: breadcrumb.text }}/>
                        }
                      </Link>
                      <span className="sep">{separator}</span>
                    </> : <span key="title" dangerouslySetInnerHTML={{ __html: breadcrumb.text }}/>
                  }
                </div>
              );
            }
          ) : ''}
      </div>
    </div>
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
  pageUrl: PropTypes.string,
};
